import md5 from 'js-md5';

export function makeUploadSignature(bucket: string, fileName: string): string {
    const canonical = [bucket, fileName].join('\n');
    const firstDigest = md5(canonical);
    return md5(firstDigest + 'b7f3c1a4e06d9b8c5f2a1e7c0f4d8a29');
}

export function calculateFileMD5(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (event: ProgressEvent<FileReader>) => {
            if (event.target && event.target.result) {
                try {
                    const arrayBuffer = event.target.result as ArrayBuffer;
                    const hash = md5(new Uint8Array(arrayBuffer));
                    resolve(hash);
                } catch (error) {
                    reject(new Error('MD5 calculation failed'));
                }
            } else {
                reject(new Error('File reading failed'));
            }
        };

        reader.onerror = () => {
            reject(new Error('File reading error'));
        };

        reader.readAsArrayBuffer(file);
    });
}